import React, { useEffect, useState, useRef } from 'react';
import { View, ScrollView, Dimensions, TouchableWithoutFeedback, SafeAreaView, StyleSheet } from 'react-native';
import moment from 'moment';

import StaticSafeAreaInsets from 'react-native-static-safe-area-insets';

import BackHeader from './backHeader';
import Header from './header';
import Item from './item';
import NCFileDetails from './NCFileDetailsModalWrapper';

import { generateConfig } from './functions';

let popupTimeout = null;
let initTime = null;
let intervalId;
const refStorage = {};

export default (props) => {
  const {
    machines,
    C,
    minimumTileSize = 2,
    Loading,
    isBackHeader,
    isWeb,
    isFullScreen,
    wallboardSelectedLevel,
    getWallboardEventTimeline,
    localTime,
    fullWidth: pageWidth,
    height: pageHeight,
    Shadow,
    wallboardTimelineEndDate,
    setTimeLineNotLoaded,
    controlAPICall,
    scrollViewRef,
    handleOnScrollEvent,
    filterMachinesByGroup,
    setFilterMachinesByGroup,
    nativeID,
  } = props;

  const [config, setConfig] = useState({});
  const [loaded, setLoaded] = useState(false);
  const [showHeader, setShowHeader] = useState(false);
  const [popupConfig, setPopupConfig] = useState({ show: false });
  const [wallboardLevel, triggerWallboardLevel] = useState(false);

  const filteredMachines = filterMachinesByGroup
    ? machines.filter((machine) => machine.machineGroups?.some((group) => group.machineGroupId === filterMachinesByGroup))
    : machines;

  const scrollPositionRef = useRef(0);
  const [latestScrollPosition, setLatestScrollPosition] = useState(0);

  const handleScroll = (event) => {
    const position = event.nativeEvent.contentOffset.y;
    scrollPositionRef.current = position;
    setLatestScrollPosition(position); // update state if you need to trigger re-renders
  };

  const abortControllerEventStart = useRef();
  const abortControllerEventEnd = useRef();
  const abortControllerNcFile = useRef();

  const popupWidth = 690;
  const popupHeight = 304;
  const paddingHorizontal = 32;
  const paddingVertical = 36;
  const lineBlockHeight = 99;

  const triggerShowPopup = (config) => {
    if (popupTimeout) {
      clearTimeout(popupTimeout);
    }

    setShowHeader(false);

    const { position, width, item } = config;
    // delay time block
    const lastTimeOpened = initTime ? moment().diff(moment(initTime), 'milliseconds') : 0;
    const delay = initTime ? (lastTimeOpened > 1000 ? 500 : 1000 - lastTimeOpened) : 1;
    //

    // position block
    // left
    let left = position.left + paddingHorizontal + width / 2 - popupWidth / 2;
    if (left < paddingHorizontal) {
      left = paddingHorizontal;
    } else {
      const maxLeft = pageWidth - paddingHorizontal - popupWidth;
      if (left > maxLeft) {
        left = maxLeft;
      }
    }
    //

    // position block
    // top
    let scrollBlock = 0;
    let scrollTop = 0;

    if (isWeb) {
      scrollTop = item.machineIndex * 135 + 135;
    } else {
      scrollTop = item.machineIndex * 135 + 110;
    }

    let top = position.top + scrollTop;
    const elementOffsetTop = top - latestScrollPosition;
    const isEnoughSpaceBottom = pageHeight - (elementOffsetTop + popupHeight) > 0;
    const isEnoughSpaceTop = elementOffsetTop - lineBlockHeight / 2 > popupHeight;
    let isBottom = true;
    if (!isEnoughSpaceBottom) {
      if (isEnoughSpaceTop) {
        isBottom = false;
        top = top - lineBlockHeight / 2 - popupHeight;
      }
    }
    //
    initTime = moment().format();

    const result = () =>
      setPopupConfig({
        show: true,
        position: {
          left,
          top,
        },
        elementPosition: {
          top,
          left: position.left + paddingHorizontal + width / 2 - left,
        },
        isBottom,
        item,
      });

    if (isWeb) {
      popupTimeout = setTimeout(() => {
        result();
      }, delay);
    } else {
      result();
    }
  };

  const triggerHidePopup = () => {
    if (popupTimeout) {
      clearTimeout(popupTimeout);
    }
    popupTimeout = setTimeout(() => {
      setPopupConfig({ show: false });
    }, 300);
  };

  const clearPopupTimeout = () => {
    if (popupTimeout) {
      clearTimeout(popupTimeout);
    }
  };

  const init = () => {
    for (const index in filteredMachines) {
      const machine = filteredMachines[index];
      if (!machine?.isEmpty) {
        let machineRef = refStorage[machine.machineId];
        if (!machineRef) {
          refStorage[machine.machineId] = { current: null };
          machineRef = refStorage[machine.machineId];
        }
        controlAPICall(getWallboardEventTimeline, { id: machine.machineId }, machineRef);
      }
    }
  };

  useEffect(() => {
    for (const index in filteredMachines) {
      const machine = filteredMachines[index];
      setTimeLineNotLoaded({ id: machine.machineId });
    }

    init();

    const visibilitychange = async () => {
      if (!window.document.hidden) {
        init();
      }
    };

    if (isWeb) {
      window.document.addEventListener('visibilitychange', visibilitychange);
    }

    return () => {
      if (isWeb) {
        window.document.removeEventListener('visibilitychange', visibilitychange);
      }
      clearInterval(intervalId);
    };
  }, [wallboardTimelineEndDate, wallboardSelectedLevel]);

  const rerender = () => {
    const func = (v) => {
      const list = machines;

      const { c, orientation } = generateConfig({ initialMachines: list, minimumTileSize, ...v });
      setConfig({ ...c, orientation });

      setLoaded(true);
    };
    if (StaticSafeAreaInsets) {
      StaticSafeAreaInsets.getSafeAreaInsets(func);
    } else {
      func({ safeAreaInsetsBottom: 0, safeAreaInsetsTop: 87, safeAreaInsetsLeft: 0, safeAreaInsetsRight: 0 });
    }
  };

  useEffect(() => {
    rerender();

    Dimensions.removeEventListener('change', rerender);

    Dimensions.addEventListener('change', rerender);

    return () => {
      Dimensions.removeEventListener('change', rerender);
    };
  }, [minimumTileSize, isFullScreen]);

  if (!loaded) {
    return <Loading />;
  }

  const { tileHeight, tileWidth, left, rigth, top, bottom, scaleFactor, horizTiles, verticalTiles, width, height } = config;

  const scale = (v) => Math.round(v * scaleFactor);
  const isNow = wallboardSelectedLevel === 'live';

  const lineWidth = config.width - 64;

  const hourWidth = lineWidth / 24;
  const minWidth = hourWidth / 60;
  const secondWidth = minWidth / 60;

  return [
    <ScrollView
      style={[
        { backgroundColor: C(isNow ? 'Background/Light/Wallboard Tile Screen' : 'Background/Light/System') },
        isWeb && { display: 'block', marginTop: 43 },
      ]}
      key="machinesList"
      nativeID={nativeID || "scroll-block"}
      onScrollEndDrag={handleScroll}
      onScroll={handleOnScrollEvent || (() => {})}
      ref={scrollViewRef}
    >
      <TouchableWithoutFeedback
        onPress={() => {
          if (popupConfig.show) {
            return setPopupConfig({ show: false });
          }
          setShowHeader(!showHeader);
        }}
      >
        <SafeAreaView style={{ minWidth: width, minHeight: height, position: 'relative' }}>
          {wallboardSelectedLevel == 'last24' && (
            <View
              style={{
                position: 'absolute',
                width: StyleSheet.hairlineWidth,
                height: '100%',
                minHeight: height,
                backgroundColor: C('Hairline/Light/No trans'),
                left: 32 + secondWidth * (86400 - localTime().diff(localTime().startOf('day'), 'second')),
              }}
              key={'MiddleLine'}
            />
          )}
          <View
            style={
              isNow
                ? {
                    minWidth: '100%',
                    minHeight: '100%',
                    flexWrap: 'wrap',
                    paddingLeft: left,
                    paddingRight: rigth,
                    paddingTop: top,
                    paddingBottom: bottom,
                    flexDirection: 'row',
                  }
                : { minWidth: '100%', minHeight: '100%', flexWrap: 'wrap', paddingHorizontal, paddingVertical }
            }
          >
            {popupConfig.show && (
              <NCFileDetails
                {...{
                  ...props,
                  popupConfig,
                  popupWidth,
                  popupHeight,
                  clearPopupTimeout,
                  triggerHidePopup,
                  Shadow,
                  abortControllerEventStart,
                  abortControllerEventEnd,
                  abortControllerNcFile,
                }}
              />
            )}
            {filteredMachines.map((machine, index) => {
              const { machineId } = machine;

              const isLastLine = index + 1 > filteredMachines.length - horizTiles;
              const isLastInLine = (index + 1) % horizTiles === 0;

              if (machine.isEmpty) {
                return isNow ? (
                  <View
                    key={machineId}
                    style={{
                      height: tileHeight,
                      width: tileWidth,
                      marginBottom: isLastLine ? 0 : 12,
                      marginRight: isLastInLine ? 0 : 12,
                    }}
                  />
                ) : null;
              }

              return (
                <Item
                  {...{
                    ...props,
                    machine,
                    index,
                    scale,
                    config,
                    isLastLine,
                    isLastInLine,
                    triggerShowPopup,
                    triggerHidePopup,
                    filterMachinesByGroup,
                  }}
                  key={`Machine-${machineId}`}
                />
              );
            })}
          </View>
        </SafeAreaView>
      </TouchableWithoutFeedback>
    </ScrollView>,
    isWeb && <Header {...{ ...props, machines, setFilterMachinesByGroup }} key="header" />,
    showHeader && isBackHeader && <BackHeader {...{ ...props, wallboardLevel, triggerWallboardLevel }} key="BackHeader" />,
  ];
};
